import React, { useState, useEffect} from 'react'
import Logo from "../images/edayalogo.svg";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MobileDownloadAlert from './alert/MobileDownloadAlert';

const Logoheader = () => {
  const guestName = localStorage.getItem("appUserName");
  const layoutWraper = useSelector((store) => store.layout.layoutWraper);
  const [open, setOpen] = useState(true);


  useEffect(() => {
    const isBannerDismissed = sessionStorage.getItem('alertbannerDismissed');
    if (isBannerDismissed) {
      setOpen(false);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);

    sessionStorage.setItem('alertbannerDismissed', 'true');
  };
  const handleRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
     if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.edaya.guestapp&pli=1";
    }
     else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    } 
     else { 
      window.location.href = "https://edayaapp.com/appDownloadlink";  
    }
  };
  return (
    <>
    <div className="login-head flex justify-between items-center section-wrap lg:py-3 min-h-[60px] py-2">
        <img className="h-5" src={Logo} alt="" />
        <div className="flex items-center gap-3">
          {!open &&  <div  onClick={()=>handleRedirect()}  target="_blank" className="download-btn cursor-pointer"> Download App</div> }
            {(layoutWraper) && (guestName ? <Link to="../profile" className='avatar top-nav'>{guestName[0]}</Link> : <Link to="../login" className='download-btn min-w-[120px] top-nav text-center flex justify-center' style={{background:""}}>Login</Link>)}
        </div>
      </div>
      {open && <MobileDownloadAlert handleClose={()=>handleClose()}/>}
      </>
  )
}

export default Logoheader
